<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-3">
      <div
        class="p-1.5 rounded-sm"
        :style="{
          background: color,
        }"
      />
      <span>{{ title }}</span>
    </div>
    <p>{{ value }} {{ subTitle }}</p>
  </div>
</template>

<script>
export default {
  name: "LoanLegend",
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    color: {
      type: String,
    },
  },
};
</script>
